module.exports = __webpack_public_path__ + "static-v-shop/1765544401094/img/logo_master.c8bdcd8d.svg";